import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../../../spa/Components/Link/Link';
import {
    MESSAGE_BUTTON_BLOCK,
    MESSAGE_BUTTON_BLOCK_CONTAINER,
    MESSAGE_BUTTON_BLOCK_MESSAGE,
    MESSAGE_BUTTON_BLOCK_BUTTON,
    MESSAGE_BUTTON_BLOCK_TITLE,
} from './constants';
import './styles/message-button-card.scss';

const propTypes = {
    title: PropTypes.string,
    MessageIconClassName: PropTypes.string,
    button: PropTypes.string,
    link: PropTypes.string,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object),
    ]).isRequired,
};

const baseClass = 'bb-message-button-card';

/**
 * MessageButtonCard
 *
 * Simple card with an Icon, message and a button
 * No-Result icon is set by default
 * a tag would be replaced by a RouterLink component when SPA is fully supported
 *
 * @param {String} icon Icon class name
 * @param {String} title title to display
 * @param {String} message Message/label to display
 * @param {String} button Label to display in the button
 * @param {String} link URL to redirect when button pressed
 * @return {React} React component
 */
class MessageButtonCard extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { MessageIconClassName, title, message, button, link } = this.props;
        const MessageIconClass = typeof MessageIconClassName !== 'undefined' ? `${baseClass}__icon ${baseClass}__icon-${MessageIconClassName}` : '';
        const Button = ((typeof button !== 'undefined') && (typeof link !== 'undefined')) ?
        <Link to={link} className={MESSAGE_BUTTON_BLOCK_BUTTON} target='_self'><span>{button}</span></Link> : '';

        return (
            <div className={MESSAGE_BUTTON_BLOCK}>
                <div className={MESSAGE_BUTTON_BLOCK_CONTAINER}>
                    <div className={MessageIconClass}></div>
                    <h1 className={MESSAGE_BUTTON_BLOCK_TITLE}>
                        {title}
                    </h1>
                    <p className={MESSAGE_BUTTON_BLOCK_MESSAGE}>
                        {message}
                    </p>
                    {Button}
                </div>
            </div>
        );
    }
}

MessageButtonCard.propTypes = propTypes;

export default MessageButtonCard;
